import { BaseConvocatoriaService } from "../base/baseApiConvocatoria";

export class DocumentosGeneralesService extends BaseConvocatoriaService {


    async getDocumentosGenerales (idConvocatoria) {
        try {
            const { data } = await this.axiosClient.get(`${process.env.REACT_APP_SERVER_CONV}convocatorias/consultarDocumentosGenerales/${44}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in postConvocatoria with stack: ${error}`);
        }
    }

    async getArchivo (url_documento) {
        try {
            const  data  = await this.axiosClient.get(`${process.env.REACT_APP_SERVER_CONV}documentos/consultarArchivos/${url_documento}`,
              {
                responseType: "blob",
              });
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in postConvocatoria with stack: ${error}`);
        }
    }

    async postArchivo (formData) {
        try {
            const { data } = await this.axiosClient.post(`${process.env.REACT_APP_SERVER_CONV}documentos/guardarArchivo`, formData, 
              {
                headers: { "content-type": "multipart/form-data" },
              })
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in postConvocatoria with stack: ${error}`);
        }
    }

    async postDocumentosTecnicos (idConvocatoria, documentos_generales ) {
        try {
            const { data } = await this.axiosClient.post(`${process.env.REACT_APP_SERVER_CONV}convocatorias/documentos_generales/${idConvocatoria}`, documentos_generales)
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in postConvocatoria with stack: ${error}`);
        }
    }

}

export default new DocumentosGeneralesService();